var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 128 128",
    enableBackground: "new 0 0 128 128",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M8.2,107.6c9.2,4.3,18.4,8.7,27.6,13.1c0.4,0.3,1.1,0.3,1.6,0.3c7,0,14,0,21,0c1.2,0,1.4-0.4,1.4-1.5 c-0.1-6.2,0-12.4,0-18.6c0-0.4-0.1-0.6-0.1-1.2c-0.5,0.3-1,0.4-1.4,0.6c-6.4,2.8-13,5.1-20.2,4.2c-2.8-0.4-5.3-1.3-7.4-3.3 c-3.7-3.5-4.7-8.1-4.8-12.9c-0.1-4,0.3-8,0.8-12c0.5-4.7,1.7-9.2,3.7-13.5c5.3-11.7,13.1-21.7,22.3-30.5c3-2.9,6.6-5.2,10-7.8 c0.8-0.6,1.6-0.6,2.5,0c2.7,2,5.5,3.8,8,5.9c6.5,5.7,12,12.2,16.8,19.3c4.9,7.1,9,14.7,10.6,23.3c1.2,6.3,2,12.7,0.9,19.1 c-1.6,8.6-6.7,12.3-14.4,12.5c-3.8,0.1-7.5-0.7-11.1-2c-2.6-0.9-5.2-2-7.8-3c0,0.4,0,0.6,0,0.9c0,6.2,0,12.4,0,18.5 c0,1.3,0.4,1.6,1.7,1.6c6.8-0.1,13.5,0,20.3-0.1c0.9,0,1.8-0.3,2.6-0.6c8.9-4.2,17.8-8.5,26.6-12.7c1.8-0.9,1.8-0.8,1.3-2.8 c-5-19.6-9.9-39.1-14.9-58.7c-0.2-0.6-0.5-1.3-1.1-1.9c-2-2-4.1-3.9-6.1-5.8c-3.9-3.6-7.8-7.2-11.8-10.8 c-5.3-4.8-10.5-9.5-15.8-14.4c-2-1.9-4.2-3.8-6.2-5.8c-0.7-0.6-1.2-0.6-1.9,0.1c-0.9,0.9-1.9,1.7-2.8,2.5 c-4.1,3.8-8.2,7.6-12.3,11.3c-4.4,4-8.7,8-13.2,12c-3.2,2.9-6.4,5.8-9.6,8.7c-1.2,1.2-2.7,2.2-3.2,4.1c-4.9,19.5-9.8,39.1-14.8,58.6 C6.8,106.4,7,107.1,8.2,107.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScb);
export default __webpack_public_path__ + "static/media/scb.9b2e532ad3ee554021e92e3cf158d865.svg";
export { ForwardRef as ReactComponent };